import { ExternalCalibration } from '../interfaces';

export const INITIAL_PDF_DATA: ExternalCalibration = {
  sn: '',
  imo: '',
  computerSn: '',
  vessel: '',
  technician: '',
  certificateNr: '',
  batchCalCheck: '',
  serviceStationId: 0,
  dateOfCalibration: '',
  placeOfCalibration: '',

  cleanWaterValue: '',
  firstCheckIntended: '',
  firstCheckValue: '',
  secondCheckIntended: '',
  secondCheckValue: '',

  separatorMarker: '',
  separatorInfo: '',
  deckmaInfo: '',

  fiveYearly: '',
  monthly: 12,
} as ExternalCalibration;
